import { EClickableVariants } from '@/components/atoms/at-clickable/at-clickable.types';
import { OrTestimonialBlock } from './or-testimonial-block';

import { ICmsTestimonialCard } from '@/lib/contentstack-sdk/types/component';
import { ICmsTestimonialBlock } from './or-testimonial-block.types';

export const OrTestimonialBlockCS = ({ block }: ICmsTestimonialBlock) => {
  const {
    testimonial_cards: cards,
    autoplay,
    top_spacing,
    bottom_spacing,
  } = block;

  const cardData = cards?.map((card: ICmsTestimonialCard) => {
    const { author_image, headline, cta, quote } = card;

    return {
      cta: {
        label: cta[0]?.title,
        href: cta[0]?.url,
        variant: EClickableVariants[cta[0]?.variant.variant],
      },
      headline,
      images: author_image,
      quote,
    };
  });

  return (
    <OrTestimonialBlock
      cards={cardData}
      autoplay={autoplay}
      topSpacing={top_spacing?.spacing_value}
      bottomSpacing={bottom_spacing?.spacing_value}
      topDivider={top_spacing?.divider}
      bottomDivider={bottom_spacing?.divider}
    />
  );
};
